import React, { useState } from 'react';

import systemImage from './../../assets/images/static/computerBg.png';
import orangeDots from './../../assets/images/static/organeDots.png';
import LoginModal from './../../components/Modal/LoginModal';

import {
  HeroSection,
  StyledContentSection,
  ContentDiv,
  MainHeading,
  SubTitle,
  SignUpButton,
  StyledImageSection,
  StyledImgDiv,
  ImageDiv,
  Img,
  ImgIllustration,
} from './styled';

const Hero = () => {

  const [showSignUp, setSignUpModal] = useState(false);

  return (
    <HeroSection id="home">
      <StyledContentSection>
        <ContentDiv>
          <MainHeading>Electronic Retail Point</MainHeading>
          <SubTitle>E-RetailPoint is the most accessible Point-of-sale Solution for Restaurants, Pharmacies, and Retail.</SubTitle>
          <SignUpButton 
            onClick={() => setSignUpModal(true)}
          >
            Sign Up for Free
          </SignUpButton>
        </ContentDiv>
        <StyledImgDiv className="showonMobile">
        </StyledImgDiv>
      </StyledContentSection>
      <StyledImageSection className='hideonMobile'>
        <ImageDiv>
          <Img src={systemImage} alt="Pos System" />
          <ImgIllustration src={orangeDots} alt='Illustrations' />
        </ImageDiv>
      </StyledImageSection>
      { showSignUp && <LoginModal closeModal={setSignUpModal} /> }
    </HeroSection>
  )
}

export default Hero;